export function validatePassword(password: string) {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/;
  return passwordRegex.test(password);
}

export function validateOrganization(organization: string) {
  const organizationRegex = /^[a-zA-Z0-9- '_-]{2,}$/;
  return organizationRegex.test(organization);
}
